






















import { Vue, Component } from "vue-property-decorator";
import BillForm from "@/components/bill/BillForm.vue";
import { Bill as IBill } from "@/api/models/bill";
import { Contract as IContract } from "@/api/models/contract";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import api from "@/getinfo-api";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: { CBreadCrumbs, BillForm }
})
export default class BillEdit extends Vue {
  bill!: IBill | undefined;
  contract!: IContract | undefined;
  showSpinner: boolean = false;

  data() {
    return {
      bill: undefined,
      contract: undefined
    };
  }

  getBill() {
    this.bill = undefined;
    this.contract = undefined;
    this.showSpinner = true;
    api.BillApi.get(this.$route.params.billId).then((res: { data: IBill }) => {
      this.bill = res.data;
      document.title += ` ${this.bill.number}`;
      api.ContractApi.get(this.bill.contractId)
        .then((res: { data: IContract }) => {
          this.contract = res.data;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.showSpinner = false;
        });
    });
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "bills" },
        label: this.$tc(this.$translate.Bills)
      },
      {
        to: { name: "bill", params: { billId: this.bill?.id } },
        label: this.bill?.number
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  mounted() {
    this.getBill();
  }
}
